import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';

export type CardOnFileActionsProps = {
  primary: ButtonProps;
  secondary?: ButtonProps;
  shouldShow: boolean;
  shouldUsePadding?: boolean;
};

const styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: ${theme.spacing(2)};
  `,
  padding: css`
    padding: ${theme.spacing(2)};
  `,
};
export const CardOnFileActions = ({
  primary: { children: primaryChildren, ...primary },
  secondary,
  shouldShow,
  shouldUsePadding = true,
}: CardOnFileActionsProps) => {
  const { t } = useTranslation();

  const { children: secondaryChildren, ...secondaryBtn } = secondary || {};

  if (!shouldShow) {
    return null;
  }

  return (
    <div css={[styles.root, shouldUsePadding && styles.padding]}>
      {secondary && (
        <div>
          <Button {...secondary} variant={secondary.variant ?? 'secondary'} {...secondaryBtn}>
            {secondaryChildren ?? t('Cancel')}
          </Button>
        </div>
      )}

      <div>
        <Button {...primary} variant={primary.variant ?? 'primary'}>
          {primaryChildren ?? t('Add Card')}
        </Button>
      </div>
    </div>
  );
};
